<template>
	<div style="display: flex; flex-direction: column; gap: 40px">
		<Card>
			<CardGrafico
				:loading="dashboardStore.getters.isEmpty"
				:title="$t('measurement')"
				:subtitle="`Última atualização em ${new Date(dataUltimoProcessamento).toLocaleDateString(
					'pt-BR',
					{
						month: 'long',
						day: 'numeric',
						year: 'numeric',
					},
				)}`"
			>
				<template #grafico>
					<v-date-picker
						v-model="dataEscolhida"
						mode="date"
						color="green"
						:model-config="{ type: 'string' }"
						:update-on-input="false"
						@input="onDateSelected"
					>
						<!-- :available-dates="dashboardStore.state.datasMedicao" -->
						<!-- > -->
						<template #default="{ inputValue, inputEvents }">
							<div
								style="
									width: fit-content;
									border: 1px solid #ccc;
									border-radius: 5px;
									padding: 0.5rem;
									margin: 1rem 0;
								"
							>
								<i
									class="fas fa-calendar-alt"
									style="
										padding-right: 0.5rem;
										color: #72a313;
										border-right: 1px solid #ccc;
										margin-right: 0.5rem;
									"
								/>
								<input
									:value="inputValue"
									v-on="inputEvents"
								/>
							</div>
						</template>
					</v-date-picker>
					<!-- <ButtonDropdown
            v-model="dataEscolhida"
            :options="dataMedicoes"
            style="width: fit-content; padding: 1rem 0"
          /> -->
					<div style="display: flex">
						<Chart
							v-if="dashboardStore.state.customizada"
							:key="dashboardStore.state.customizada"
							ref="ref__chart"
							:options="chartOptions"
							style="width: 100%"
						/>

						<div
							v-else
							style="width: 100%; display: flex; justify-content: center; align-items: center"
						>
							<h4>{{ $t('configureUmaVariavel') }}</h4>
						</div>
						<ChartFilter
							:filters="filtros"
							:options="variaveisCustomizadasOptions"
							@fazendas="fazendasEscolhidas = $event"
							@espacamento="espacamentosEscolhidos = $event"
							@material="materiaisEscolhidos = $event"
							@plantio="plantiosEscolhidos = $event"
						/>
					</div>
				</template>
			</CardGrafico>
		</Card>
		<Card>
			<CardGrafico
				:loading="dashboardStore.getters.isEmpty"
				:title="$t('temporalEvolution')"
				:subtitle="`Última atualização em ${new Date(dataUltimoProcessamento).toLocaleDateString(
					'pt-BR',
					{
						month: 'long',
						day: 'numeric',
						year: 'numeric',
					},
				)}`"
			>
				<template #grafico>
					<div style="display: flex; justify-content: space-between; align-items: center">
						<ButtonDropdown
							v-model="unidadeTemporal"
							:options="[
								{ value: 'dap', label: i18n.t('hbd') },
								{ value: 'ht', label: 'HT' },
								{ value: 'volumeComCasca', label: i18n.t('volume') },
							]"
							style="width: fit-content; padding: 1rem 0"
						/>
						<Checkbox
							v-model="absoluta"
							:label="$t('visualizacaoRelativa')"
						/>
					</div>
					<div style="display: flex">
						<ChartFilter
							:filters="filtros"
							:options="variaveisCustomizadasOptions"
							@fazendas="fazendasEscolhidasTemporal = $event"
							@espacamento="espacamentosEscolhidosTemporal = $event"
							@material="materiaisEscolhidosTemporal = $event"
							@plantio="plantiosEscolhidosTemporal = $event"
						/>

						<Chart
							v-if="dashboardStore.state.customizada"
							:key="dashboardStore.state.customizada"
							ref="ref__chart"
							:options="temporalChartOptions"
							style="width: 100%"
						/>

						<div
							v-else
							style="width: 100%; display: flex; justify-content: center; align-items: center"
						>
							<h4>{{ $t('configureUmaVariavel') }}</h4>
						</div>
					</div>
				</template>
			</CardGrafico>
		</Card>
		<Card>
			<CardGrafico
				:loading="dashboardStore.getters.isEmpty"
				:title="$t('detailedAnalysis')"
				:subtitle="`Última atualização em ${new Date(dataUltimoProcessamento).toLocaleDateString(
					'pt-BR',
					{
						month: 'long',
						day: 'numeric',
						year: 'numeric',
					},
				)}`"
			>
				<template #grafico>
					<div style="display: flex; gap: 1.5rem">
						<ChartFilter
							:filters="filtros"
							:options="variaveisCustomizadasOptions"
							@fazendas="fazendasEscolhidasTabular = $event"
							@espacamento="espacamentosEscolhidosTabular = $event"
							@material="materiaisEscolhidosTabular = $event"
							@plantio="plantiosEscolhidosTabular = $event"
						/>
						<div
							v-if="dashboardStore.state.customizada"
							style="width: 100%; display: flex; flex-direction: column"
						>
							<div style="display: flex; justify-content: end">
								<Button
									:label="$t('exportarDados')"
									style="width: fit-content"
									@click="download(csv, 'Análise detalhada', 'text/csv')"
								/>
							</div>
							<CrudTable
								report-mode
								:headers="headersAtivos"
								:data="tabularData.slice(startIndex, endIndex)"
								:table-configuration="tableConfiguration"
							/>
							<Pagination
								ref="ref__pagination"
								style="display: flex; justify-content: end; padding: 0.5rem"
								:quantity-per-page="quantityPerPage"
								:quantity-per-page-options="[10, 15, 20]"
								:total-records="tabularData.length"
								@setStartEnd="startIndex = $event"
								@setQuantityPerPage="setQuantityPerPage"
							/>
						</div>
						<div
							v-else
							style="width: 100%; display: flex; justify-content: center; align-items: center"
						>
							<h4>{{ $t('configureUmaVariavel') }}</h4>
						</div>
					</div>
				</template>
			</CardGrafico>
		</Card>
	</div>
</template>

<script setup>
import download from 'downloadjs'
import { Chart } from 'highcharts-vue'
import { groupBy, maxBy, meanBy, minBy, orderBy } from 'lodash'
import { mean, standardDeviation } from 'simple-statistics'
import { computed, onMounted, ref, watch } from 'vue'
import Button from '../../../components/Button/Button.vue'
import ButtonDropdown from '../../../components/ButtonDropdown/ButtonDropdown.vue'
import Card from '../../../components/Card/Card.vue'
import CardGrafico from '../../../components/CardGrafico/CardGrafico.vue'
import ChartFilter from '../../../components/ChartFilter/ChartFilter.vue'
import Checkbox from '../../../components/Checkbox/Checkbox.vue'
import CrudTable from '../../../components/CrudTable/CrudTable.vue'
import Pagination from '../../../components/Pagination/Pagination.vue'
import { useStore } from '../../../store/modules/moduleDashboardAnalytics'
import { getDropdownEstratosFlorestais } from '../../../services/requests/EstratoFlorestalRequests'
import i18n from '../../../VueI18n'
const dashboardStore = useStore()
const dashboard = ref(dashboardStore.state.dashboardData)

// Mapeamento de estratos (ID -> Nome)
const estratosMap = ref({})
const estratosLoaded = ref(false)

const unidadeTemporal = ref('volumeComCasca')

// Carregar estratos imediatamente (antes do mount)
const carregarEstratos = async () => {
	try {
		const estratos = await getDropdownEstratosFlorestais()
		const novoMap = {}
		estratos.forEach((estrato) => {
			novoMap[estrato.id] = `EF-${estrato.esfl_cd_codigo} - ${estrato.esfl_ds_descricao}`
		})
		estratosMap.value = novoMap
		estratosLoaded.value = true
	} catch (error) {
		console.error('Erro ao carregar estratos:', error)
		estratosLoaded.value = true // Marca como carregado mesmo com erro
	}
}

// Inicia o carregamento imediatamente
carregarEstratos()

onMounted(() => {
	if (dashboardStore.getters.isEmpty) {
		dashboardStore.commit('setDashboardData')
	}
})

function setQuantityPerPage(quantity) {
	quantityPerPage.value = quantity
}

const quantityPerPage = ref(10)
const startIndex = ref(0)
const endIndex = computed(() => startIndex?.value + quantityPerPage?.value)
const fazendasEscolhidas = ref([])
const espacamentosEscolhidos = ref([])
const plantiosEscolhidos = ref([])
const materiaisEscolhidos = ref([])
const fazendasEscolhidasTemporal = ref([])
const espacamentosEscolhidosTemporal = ref([])
const plantiosEscolhidosTemporal = ref([])
const materiaisEscolhidosTemporal = ref([])
const fazendasEscolhidasTabular = ref([])
const espacamentosEscolhidosTabular = ref([])
const plantiosEscolhidosTabular = ref([])
const materiaisEscolhidosTabular = ref([])
const headersSelecionados = ref([
	'espacamento',
	'tratamento',
	'materialGenetico',
	'volume',
	'dap',
	'variacaoVolume',
	'ht',
	'dp',
	'cv',
])
const tableConfiguration = ref({
	statusTable: 'Carregando' + '...',
	prefix: 'ES',
	subtitleCardPropertie: 'espe_ds_nome',
	titleCardPropertie: 'espe_cd_codigo',
})

const absoluta = ref(false)

const suffix = ref({
	dap: ' cm',
	ht: ' m',
	volumeComCasca: ' m³/ha',
})

function onDateSelected(date) {
	const dateString = date.toString()

	const dateExist = dashboardStore.state.datasMedicao.includes(dateString)
	if (!dateExist) {
		dashboardStore.commit('setDashboardDatePicker', dateString)
	}
}

function filterMedicao(medicao) {
	const hasFazenda = fazendasEscolhidas?.value.length
		? fazendasEscolhidas?.value.includes(medicao.fazendaId)
		: true
	const hasEspacamento = espacamentosEscolhidos?.value.length
		? espacamentosEscolhidos?.value.includes(medicao.espacamento)
		: true
	const hasMaterialGenetico = materiaisEscolhidos?.value.length
		? materiaisEscolhidos?.value.includes(medicao.materialGenetico)
		: true
	const hasCustomizada = plantiosEscolhidos?.value.length
		? plantiosEscolhidos?.value.includes(medicao.customizada)
		: true

	return hasFazenda && hasEspacamento && hasMaterialGenetico && hasCustomizada
}

function filterMedicaoTemporal(medicao) {
	const hasFazenda = fazendasEscolhidasTemporal?.value.length
		? fazendasEscolhidasTemporal?.value.includes(medicao.fazendaId)
		: true
	const hasEspacamento = espacamentosEscolhidosTemporal?.value.length
		? espacamentosEscolhidosTemporal?.value.includes(medicao.espacamento)
		: true
	const hasMaterialGenetico = materiaisEscolhidosTemporal?.value.length
		? materiaisEscolhidosTemporal?.value.includes(medicao.materialGenetico)
		: true
	const hasCustomizada = plantiosEscolhidosTemporal?.value.length
		? plantiosEscolhidosTemporal?.value.includes(medicao.customizada)
		: true

	return hasFazenda && hasEspacamento && hasMaterialGenetico && hasCustomizada
}

function filterMedicaoTabular(medicao) {
	const hasFazenda = fazendasEscolhidasTabular?.value.length
		? fazendasEscolhidasTabular?.value.includes(medicao.fazendaId)
		: true
	const hasEspacamento = espacamentosEscolhidosTabular?.value.length
		? espacamentosEscolhidosTabular?.value.includes(medicao.espacamento)
		: true
	const hasMaterialGenetico = materiaisEscolhidosTabular?.value.length
		? materiaisEscolhidosTabular?.value.includes(medicao.materialGenetico)
		: true
	const hasCustomizada = plantiosEscolhidosTabular?.value.length
		? plantiosEscolhidosTabular?.value.includes(medicao.customizada)
		: true

	return hasFazenda && hasEspacamento && hasMaterialGenetico && hasCustomizada
}

const customizadasUnicas = computed(() => {
	if (!dashboardStore.state.customizada) return []

	// Se a variável selecionada for "Estrato", retorna os estratos únicos
	if (dashboardStore.state.customizada === 'Estrato') {
		// Só processa se os estratos já foram carregados
		if (!estratosLoaded.value) return []

		return [
			...new Set(
				medicoes?.value
					.map((medicao) => {
						// Retorna o nome do estrato mapeado
						return estratosMap.value[medicao.estratoFlorestalId] || medicao.estratoFlorestalId
					})
					.filter((estrato) => estrato !== undefined && estrato !== null),
			),
		]
	}

	// Caso contrário, busca nas variáveis customizadas normais
	return [
		...new Set(
			plantios?.value.map(
				(plantio) =>
					plantio.variavelCustomizada.find((vc) => vc.name === dashboardStore.state.customizada)
						?.value,
			),
		),
	]
})

const tableHeaders = computed({
	get() {
		return [
			{
				key: 'tratamento',
				value: dashboardStore.state.customizada,
				isActive: true,
			},
			{ key: 'espacamento', value: this.$t('spacing'), isActive: true },
			{
				key: 'materialGenetico',
				value: this.$t('geneticMaterial'),
				isActive: true,
			},
			{
				key: 'volume',
				value: this.$t('volMedioAnaliseDetalhada'),
				isActive: true,
			},
			{
				key: 'dap',
				value: this.$t('dapMedioAnaliseDetalhada'),
				isActive: true,
			},
			{
				key: 'ht',
				value: this.$t('htMedioAnaliseDetalhada'),
				isActive: true,
			},
			{
				key: 'dp',
				value: this.$t('desvioPadraoAnaliseDetalhada'),
				isActive: true,
			},
			{
				key: 'cv',
				value: this.$t('coefiVariacaoAnaliseDetalhada'),
				isActive: true,
			},
			{
				key: 'variacaoVolume',
				value: this.$t('amplitudeVolAnaliseDetalhada'),
				isActive: true,
			},
		]
	},
	set(e) {
		headersSelecionados.value = e.map((m) => m.key)
	},
})

const headersAtivos = computed(() => {
	const ativos = tableHeaders?.value.filter((f) => headersSelecionados?.value.includes(f.key))

	ativos.forEach((f) => {
		f.isActive = true
	})

	return ativos
})

const plantios = computed(() => {
	return dashboardStore.state.dashboardData.fazendas
		.map((fazenda) => fazenda.dadosNivelPlantio.map((plantio) => plantio))
		.flat()
})

const tabularData = computed(() => {
	if (!customizadasUnicas?.value || !Array.isArray(customizadasUnicas.value)) return []

	return customizadasUnicas.value
		.filter((f) =>
			plantiosEscolhidosTabular?.value.length ? plantiosEscolhidosTabular?.value.includes(f) : f,
		)
		.map((customizada) => {
			const medicoesGrupo = medicoesAgrupadasPorCustomizada?.value[customizada]
			if (!medicoesGrupo || !Array.isArray(medicoesGrupo)) return null

			const medicoes = medicoesGrupo.filter(filterMedicaoTabular)

			return medicoes.length
				? {
						espacamento: [...new Set(medicoes.map((m) => m.espacamento))].toString(),
						tratamento: customizada,
						materialGenetico: [...new Set(medicoes.map((m) => m.materialGenetico))].toString(),
						volume: Number(meanBy(medicoes, (o) => o.volumeComCasca).toFixed(2)),
						dap: Number(meanBy(medicoes, (o) => o.dap).toFixed(2)),
						ht: Number(meanBy(medicoes, (o) => o.ht).toFixed(2)),
						variacaoVolume: Number(
							Math.abs(
								maxBy(medicoes, (o) => o.volumeComCasca).volumeComCasca -
									minBy(medicoes, (o) => o.volumeComCasca).volumeComCasca,
							).toFixed(2),
						),
						dp: Number(standardDeviation(medicoes.map((m) => m.dap)).toFixed(2)),
						cv: (
							Number(
								(
									standardDeviation(medicoes.map((m) => m.dap)) / mean(medicoes.map((m) => m.dap))
								).toFixed(2),
							) * 100
						).toFixed(2),
					}
				: null
		})
		.filter((f) => f !== null && Object?.values(f).length)
})

const csv = computed(() => {
	const header = Object.keys(tabularData?.value.slice(startIndex?.value, endIndex?.value)[0]).map(
		(m) => tableHeaders?.value.find((f) => f.key === m)?.value,
	)
	const data = tabularData?.value
		.slice(startIndex?.value, endIndex?.value)
		.map((m) => Object?.values(m))

	return [header, ...data].map((m) => m.join(';')).join('\r\n')
})

const medicoes = computed(() => {
	let m = plantios?.value
		.map((plantio) => plantio.medicoes.map((medicao) => Object.assign(medicao, plantio)))
		.flat()

	m.forEach((medicao) => delete medicao.medicoes)
	m = m.sort((a, b) =>
		new Date(a.dataMedicao).getTime() > new Date(b.dataMedicao).getTime() ? 1 : -1,
	)
	return m
})

const medicoesAgrupadasPorCustomizada = computed(() => {
	return dashboardStore.state.customizada ? groupBy(medicoes?.value, 'customizada') : []
})

watch(
	[() => dashboardStore.state.customizada, dashboard, estratosLoaded],
	([value]) => {
		if (value && medicoes?.value.length) {
			medicoes.value.forEach((medicao) => {
				// Se a variável escolhida for "Estrato", usa o estratoFlorestalId
				if (value === 'Estrato') {
					// Só mapeia se os estratos foram carregados
					if (estratosLoaded.value && estratosMap.value[medicao.estratoFlorestalId]) {
						medicao.customizada = estratosMap.value[medicao.estratoFlorestalId]
					} else {
						medicao.customizada = medicao.estratoFlorestalId
					}
				} else {
					// Caso contrário, busca na lista de variáveis customizadas
					medicao.customizada = medicao.variavelCustomizada?.find((vc) => vc.name === value)?.value
				}
			})
		}
	},

	{ immediate: true },
)

watch(
	fazendasEscolhidasTemporal,
	(novaSelecao) => {
		if (novaSelecao.length === 1) {
			// pega o primeiro ID de fazenda selecionado
			dashboardStore.commit('setClimateForFarm', novaSelecao[0])
		} else {
			// se não houver fazenda selecionada, reseta o clima
			dashboardStore.commit('clearClimate')
		}
	},
	{ immediate: true, deep: true },
)

const precipitacao = computed(() => {
	return dashboardStore.state.climate
		.map(({ date, precipitation }) => [new Date(date).getTime(), precipitation])
		.sort((precipitacao1, precipitacao2) => precipitacao1[0] - precipitacao2[0])
})

const temperatura = computed(() => {
	return dashboardStore.state.climate
		.map(({ date, temperatureMean }) => [new Date(date).getTime(), temperatureMean])
		.sort((temperatura1, temperatura2) => temperatura1[0] - temperatura2[0])
})

const umidade = computed(() => {
	return dashboardStore.state.climate
		.map(({ date, humidityMean }) => [new Date(date).getTime(), humidityMean])
		.sort((umidade1, umidade2) => umidade1[0] - umidade2[0])
})

function serieTratamentoTemporal(customizada) {
	const groupedByCustom = groupBy(medicoes?.value.filter(filterMedicaoTemporal), 'customizada')

	const groupedByDate = groupBy(groupedByCustom[customizada], 'dataMedicao')

	const entries = orderBy(Object.entries(groupedByDate), (o) => new Date(o[0]).getTime(), ['asc'])

	const primeira = absoluta?.value
		? meanBy(entries[0][1].filter(filterMedicaoTemporal), unidadeTemporal?.value)
		: 0

	const data = entries.map((entry, index) => {
		return [
			new Date(entry[0]).getTime(),
			absoluta?.value && index === 0
				? 0
				: meanBy(entry[1].filter(filterMedicaoTemporal), unidadeTemporal?.value) - primeira,
		]
	})
	// .filter((f) => !isNaN(f[1]))

	return data
}

const tratamentosTemporal = computed(() => {
	if (!customizadasUnicas?.value || !Array.isArray(customizadasUnicas.value)) return []

	return customizadasUnicas.value
		.filter((f) =>
			plantiosEscolhidosTemporal?.value.length ? plantiosEscolhidosTemporal?.value.includes(f) : f,
		)
		.map((customizada) => {
			return {
				type: 'spline',
				name: customizada,
				marker: {
					enabled: false,
				},
				data: serieTratamentoTemporal(customizada),
				yAxis: 0,
				dataGrouping: { enabled: true },
				tooltip: {
					shared: true,
					split: false,
					valueDecimals: 2,
					valueSuffix: suffix?.value[unidadeTemporal?.value],
				},
			}
		})
})

const dataChartMedicao = computed(() => {
	if (!customizadasUnicas?.value || !Array.isArray(customizadasUnicas.value)) return []

	const data = orderBy(
		customizadasUnicas.value
			.filter((f) => (plantiosEscolhidos?.value.length ? plantiosEscolhidos?.value.includes(f) : f))
			.map((customizada) => {
				const medicoesGrupo = medicoesAgrupadasPorCustomizada?.value[customizada]
				if (!medicoesGrupo || !Array.isArray(medicoesGrupo)) return null

				const medicoes = medicoesGrupo
					.filter(filterMedicao)
					.filter((medicao) => medicao.dataMedicao === dataEscolhida?.value)

				if (!medicoes || medicoes.length === 0) return null

				return {
					customizada,
					dap: meanBy(medicoes, (o) => o.dap).toFixed(2),
					ht: meanBy(medicoes, (o) => o.ht).toFixed(2),
					volume: meanBy(medicoes, (o) => o.volumeComCasca).toFixed(2),
				}
			})
			.filter((item) => item !== null),
		(o) => plantiosEscolhidos?.value.indexOf(o.customizada),
	).filter(({ dap, ht, volume }) => [dap, ht, volume].some((e) => !isNaN(e)))

	return data
})

const chartOptions = computed(() => {
	return {
		chart: {
			type: 'area',
		},
		tooltip: {
			shared: true,
		},
		/**
		 * Creditos no canto inferior direito do grafico
		 */
		credits: {
			enabled: false,
		},
		/**
		 * Não usar exportacao padrao do highcharts
		 */
		exporting: {
			enabled: false,
		},
		/**
		 * Deasbilitar legendas
		 */
		legend: {
			enabled: true,
		},
		/**
		 * Opcoes na hora de plotar o grafico
		 */
		plotOptions: {
			line: {
				dataLabels: {
					enabled: true,
				},
			},
			series: {
				/**
				 * Animacao de 2 segundos
				 */
				animation: {
					duration: 1000,
				},
			},
		},
		/**
		 * Dados que devem ser colocados no grafico
		 */
		series: [
			{
				name: i18n.t('volumeHA'),
				type: 'column',
				yAxis: 1,
				color: '#72A313',
				data: dataChartMedicao?.value.map((m) => Number(m.volume)),
				tooltip: {
					valueSuffix: ' m³/ha',
				},
			},
			{
				name: i18n.t('hbd') + '(cm)',
				type: 'spline',
				color: '#910000',

				data: dataChartMedicao?.value.map((m) => Number(m.dap)),
				tooltip: {
					valueSuffix: ' cm',
				},
			},
			{
				name: 'HT (m)',
				type: 'spline',
				color: '#492970',

				data: dataChartMedicao?.value.map((m) => Number(m.ht)),
				tooltip: {
					valueSuffix: ' m',
				},
			},
		],
		/**
		 * Titulo do grafico
		 */
		title: {
			text: '',
		},
		/**
		 * Balão ao passar o mouse sobre as barras
		 */
		// tooltip: {
		//   formatter: function () {
		//     let result = `
		//           <div class="container__graficofazenda__tooltip">
		//               <div class="container__graficofazenda__tooltip__fazenda">
		//                   <div class="container__graficofazenda__tooltip__fazenda__nome"> ${this.point.options.fazenda.nome}</div> <br/>
		//                   <div class="container__graficofazenda__tooltip__fazenda__info">
		//                     <span>Idade dos Plantios</span>
		//                     <span>${this.point.options.fazenda.idade} (ano)</span>
		//                   </div>
		//                   <div class="container__graficofazenda__tooltip__fazenda__info">
		//                     <span>Volume Total</span>
		//                     ${this.point.options.fazenda.volumeTotal} (m³)
		//                   </div>
		//                   <div class="container__graficofazenda__tooltip__fazenda__info">
		//                     <span>Volume Médio</span>
		//                     ${this.point.options.fazenda.volumeMedio} (m³/ha)
		//                   </div>
		//                   <div class="container__graficofazenda__tooltip__fazenda__info">
		//                     <span>Incremento Médio Anual</span>
		//                     ${this.point.options.fazenda.incrementoMedioAnual} (m³/ha/ano)
		//                   </div>
		//               </div>
		//           </div>`;

		//     return result;
		//   },
		//   backgroundColor: "#333647",
		//   borderRadius: 10,
		//   borderWidth: 0,
		//   outside: true,
		//   shadow: false,
		//   useHTML: true,
		// },
		/**
		 * Eixo X
		 */
		xAxis: {
			allowDecimals: false,
			categories: dataChartMedicao?.value.map((m) => m.customizada),
			title: {
				text: dashboardStore.state.customizada,
				style: {
					fontFamily: 'Open Sans, sans-serif',
					fontSize: '.8rem',
					fontWeight: 600,
				},
			},
			labels: {
				style: {
					color: '#01395e',
					fontFamily: 'Open Sans, sans-serif',
					fontSize: '.8rem',
					fontWeight: 700,
				},
			},
		},
		/**
		 * Eixo Y
		 */
		yAxis: [
			{
				// Primary yAxis
				// labels: {
				//     format: '{value}°C',
				//     style: {
				//         color: "#72A313"
				//     }
				// },
				title: {
					text: 'HT',
					style: {
						// color: Highcharts.getOptions().colors[1],
					},
				},
				labels: {
					format: '{value}',
				},
			},
			{
				// Secondary yAxis
				title: {
					text: i18n.t('volume'),
					style: {
						// color: Highcharts.getOptions().colors[0],
					},
				},
				labels: {
					format: '{value}',
				},
				// labels: {
				//     format: '{value} mm',
				//     style: {
				//         color: Highcharts.getOptions().colors[0]
				//     }
				// },
				opposite: true,
			},
			{
				//Ternary yAxis
				title: {
					text: 'DAP',
					style: {
						// color: Highcharts.getOptions().colors[2],
					},
				},
				// labels: {
				//   format: "{value} m³/ha",
				//   style: {
				//     color: Highcharts.getOptions().colors[2],
				//   },
				// },
				opposite: false,
			},
		],
	}
})

const dataEscolhida = ref(dashboardStore.state.dataUltimoProcessamento)

watch(
	() => dashboardStore.state.dataUltimoProcessamento,
	function (value) {
		dataEscolhida.value = value
	},
)

const dataUltimoProcessamento = computed(() => {
	return dashboardStore.state.dataUltimoProcessamento
})

const temporalChartOptions = computed(() => {
	return {
		navigator: {
			enabled: true,
			//series: serieFactory('Média dos Tratamentos', '#000000', avg.sort(), 0, 0)
		},
		chart: {
			zoomType: 'xy',
		},
		legend: {
			align: 'right',
			layout: 'proximate',
		},
		rangeSelector: { selected: 1 },
		title: { text: '' },
		xAxis: { ordinal: false, type: 'datetime' },
		yAxis: dashboardStore.state.climate.length
			? [
					{
						labels: {
							align: 'right',
							x: -3,
							format: `{value} ${suffix?.value[unidadeTemporal?.value]}`,
						},
						title: { text: dashboardStore.state.customizada },
						height: dashboardStore.state.climate.length ? '40%' : '100%', //"40%",
						marker: { enabled: false },
						lineWidth: 2,
					},
					{
						labels: { align: 'right', x: -3, format: '{value} %' },
						title: { text: 'Umidade (%)' },
						top: '45%',
						height: '15%',
						marker: {
							enabled: false,
						},
						offset: 0,
						lineWidth: 2,
					},
					{
						labels: { align: 'right', x: -3, format: '{value} ºC' },
						title: { text: 'Temperatura (ºC)' },
						top: '65%',
						height: '15%',
						marker: {
							enabled: false,
						},
						offset: 0,
						lineWidth: 2,
					},
					{
						labels: { align: 'right', x: -3, format: '{value} mm' },
						title: { text: 'Precipitação (mm)' },
						top: '85%',
						height: '15%',
						offset: 0,
						lineWidth: 2,
					},
				]
			: [
					{
						labels: {
							align: 'right',
							x: -3,
							format: `{value} ${suffix?.value[unidadeTemporal?.value]}`,
						},
						title: { text: dashboardStore.state.customizada },
						height: dashboardStore.state.climate.length ? '40%' : '100%', //"40%",
						marker: { enabled: false },
						lineWidth: 2,
					},
				],
		exporting: { enabled: false },
		tooltip: {
			shared: true,
			valueDecimals: undefined,
		},
		credits: {
			enabled: true,
			text: 'www.smartforest.com.br',
			href: 'https://www.smartforest.com.br',
		},
		series: dashboardStore.state.climate.length
			? [
					...tratamentosTemporal.value,
					{
						type: 'spline',
						name: 'Temperatura (ºC)',
						color: 'green',
						data: temperatura?.value,
						yAxis: 2,
						dataGrouping: { enabled: false },
						tooltip: { shared: true, split: false, valueDecimals: 0 },
					},
					{
						type: 'spline',
						name: 'Umidade (%)',
						color: 'blue',
						data: umidade?.value,
						yAxis: 1,
						dataGrouping: { enabled: false },
						tooltip: { shared: true, split: false, valueDecimals: 0 },
					},
					{
						type: 'column',
						name: 'Precipitação (mm)',
						color: 'green',
						data: precipitacao?.value,
						yAxis: 3,
						dataGrouping: { enabled: false },
						tooltip: { shared: true, split: false, valueDecimals: 0 },
					},
				]
			: [...tratamentosTemporal.value], // <-- Dados do grafico
	}
})

const filtros = computed(() => {
	return {
		fazendas: dashboardStore.state.dashboardData.fazendas.map((dado) => {
			return { nome: dado.nome, id: dado.id }
		}),
		plantios: customizadasUnicas.value,
		espacamentos: [
			...new Set(
				dashboardStore.state.dashboardData.fazendas
					.map((dado) => dado.dadosNivelPlantio)
					.flat()
					// .filter(filtraPorFazenda)
					.map((plantio) => plantio.espacamento),
			),
		],
		materiaisGenetico: [
			...new Set(
				dashboardStore.state.dashboardData.fazendas
					.map((dado) => dado.dadosNivelPlantio)
					.flat()
					// .filter(filtraPorFazenda)
					.map((plantio) => plantio.materialGenetico),
			),
		],
	}
})

const variaveisCustomizadasOptions = computed(() => {
	// Coleta todas as variáveis customizadas existentes
	const variaveisExistentes = [
		...new Set(
			dashboardStore.state.dashboardData.fazendas
				.map((fazenda) => {
					return fazenda.dadosNivelPlantio
						.map((plantio) => {
							return plantio.variavelCustomizada
						})
						.flat()
				})
				.flat()
				.map((m) => m.name),
		),
	]

	// Adiciona "Estrato" como opção se houver estratos carregados
	if (estratosLoaded.value && Object.keys(estratosMap.value).length > 0) {
		variaveisExistentes.push('Estrato')
	}

	return variaveisExistentes
})
</script>

<style>
.container__graficomedicao__grafico {
	width: 100%;
	height: 100%;
}
</style>
